import { showsFoe, stripTags, type StorySegment, type StoryScene } from '@/content/story';

/** Speaking rate assumed when a line has no recording to time it (characters per second). */
const CHARS_PER_S = 14;

const norm = (word: string) => word.toLowerCase().replace(/[^a-z']/g, '');

/**
 * Seconds from the start of a segment's audio until its picture should change: at its `cutAt`
 * word, timed by the recording's word times when there are some, else estimated from where the
 * word sits in the line (over the clip's length, or at a typical speaking rate).
 */
export function cutDelay(
  segment: StorySegment,
  words?: readonly (readonly [string, number])[],
  seconds?: number,
): number {
  if (!segment.cutAt) return 0;
  const cue = norm(segment.cutAt);
  const timed = words?.find(([word]) => norm(word) === cue);
  if (timed) return timed[1];
  const text = stripTags(segment.text);
  const at = text.toLowerCase().indexOf(segment.cutAt.toLowerCase());
  if (at < 0) return 0;
  return (at / text.length) * (seconds ?? text.length / CHARS_PER_S);
}

/** The foe appears on the screen: the diagonal-bar wipe (other scene changes crossfade). */
export const isReveal = (from: StoryScene, to: StoryScene) => !showsFoe(from) && showsFoe(to);
